module.exports = __webpack_public_path__ + "img/features-product-mob.e1b46a5.webp";